<template>
  <table-component
    ref="foodTable"
    :data="fetchData"
    sort-by=""
    :show-caption="false"
    class="datatable"
    :show-filter="false"
    :highlight-on-click="true"
    @rowClick="clickedRow"
    v-on:rowClick="clickedRow"
    filterColumn='foodId'>
    <table-column show="foodId" label="id" :hidden="true"></table-column>
    <table-column
      show="foodEspName"
      :label="$t('health.foodManager.nameEsp')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="foodGroupId"
      :label="$t('health.foodManager.group')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="portion"
      :label="$t('health.foodManager.portion')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="fatGramsValue"
      :label="$t('health.foodManager.fat')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="proteinGramValue"
      :label="$t('health.foodManager.protein')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="energykJValue"
      :label="$t('health.foodManager.kcl')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="carbohydrateGramValue"
      :label="$t('health.foodManager.carbs')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="fibreGramValue"
      :label="$t('health.foodManager.fiber')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
<!--    <table-column
      show="waterGramValue"
      :label="$t('health.foodManager.water')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="alcoholGramsValue"
      :label="$t('health.foodManager.alcohol')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>-->

  </table-component>
</template>

<script>

import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Checkbox from '@/components/shared/forms/Checkbox';
import {faTrashAlt} from '@fortawesome/pro-light-svg-icons';
import TableRow from '../../../../components/shared/table/components/TableRow';

export default {
  name: 'FoodTable',
  components: {
    TableRow,
    TableComponent,
    TableColumn,
    Checkbox
  },

  data () {
    return {
      tablePageSize: 13,
      rowId: 0,
      hover: false,
      tableState: {
        filter: '',
        page: 1,
        sort: {}
      },
      icons: {
        trash: faTrashAlt
      }
    };
  },
  watch: {
    data: {
      handler: function () {
        this.$refs.foodTable.refresh();
      }
    }
  },
  props: {
    data: {default: () => [], type: [Array, Function]}
  },
  methods: {
    fetchData ({page, filter, sort}) {
      const tablePage = pagination.createPage(
        this.data ? this.data : [],
        this.tableState,
        [''],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    clickedRow (row) {
      this.$emit('rowClick', row);
    },
    timeFormatter (timestamp) {
      if (timestamp === null) return this.$t('health.summary.average');
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-GB');
    }
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/brand/health/components/workspace/FoodTable.vue